import styled from 'styled-components';
import { IconButtonMixin } from '../../mixins/components/IconButtonMixin';
export var StyledIconButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledIconButton",
  componentId: "c11n-8-111-1__sc-lagec-0"
})(["", ""], IconButtonMixin);